import React from 'react'
import { Typography, type TypographySize } from '../typography'
import type { CSSVariableColor } from '../../types/colors'

interface NumberUnitProps {
  value: string | number
  size?: TypographySize
  color?: CSSVariableColor | undefined
  numberSize?: TypographySize
  numberColor?: CSSVariableColor | undefined
  isBold?: boolean
  unit?: string
  children?: React.ReactNode
  prefix?: string
  suffix?: string
  className?: string
  numberClassName?: string
}

export const NumberUnit = (props: NumberUnitProps) => {
  const {
    value,
    size = 'sm',
    color = 'text-neutral-surface-80',
    numberSize = 'lg',
    numberColor = 'text-neutral-surface-100',
    isBold = true,
    unit,
    children,
    prefix,
    suffix,
    className,
    numberClassName,
  } = props

  return (
    <Typography
      variant='span'
      size={size}
      weight='regular'
      color={color}
      className={`flex items-center whitespace-nowrap gap-x-3xs ${className}`}
    >
      <Typography
        variant='span'
        size={numberSize}
        weight={isBold ? 'bold' : 'regular'}
        color={numberColor}
        className={numberClassName}
      >
        {prefix}
        {value?.toLocaleString()}
        {suffix}
      </Typography>
      {unit}
      {children}
    </Typography>
  )
}
